
















































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import MainButton from '@/shared/buttons/main-button.component.vue';
import DateFormat from '@/shared/utils/date-format';
import ErrorMonitorTag from '@/shared/utils/error-monitor-tag';
import ErrorMonitorFilter from '@/domain/error-monitor/entity/error-monitor-filter.entity';
import Pagination from '@/domain/pagination.entity';

@Component({
  components: {
    MainButton,
  },
})

export default class ErrorMonitorFiltro extends Vue {
  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({ required: true })
  filter!: ErrorMonitorFilter;

  selectedDate: Array<string> = [];

  locale: string = 'pt-BR';

  typeOptions = ErrorMonitorTag.getAllOptions();

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 100,
    defaultSort: 'name|asc',
  });

  clear() {
    this.selectedDate = [];
    this.$emit('clear-filters');
  }

  search() {
    this.filter.selectedDates = this.selectedDate;
    this.$emit('filter-changed', this.filter);
  }

  private formatDate(dates: Array<string>): Array<string> {
    if (dates && dates.length === 2) {
      return dates.map((el: string) => DateFormat.timestampToLocal(el));
    }
    return [];
  }

  get dateRangeText() {
    return this.formatDate(this.selectedDate).join(' ~ ');
  }

  setSelectedDate() {
    const dateIsBefore = moment(this.selectedDate[1]).isBefore(this.selectedDate[0]);
    if (dateIsBefore) {
      this.selectedDate.reverse();
    }
  }
}
